export default __webpack_public_path__ + "static/media/format_icon_size.c2a96170.svg";